/**
 * Global AJAX add-to-cart — runs synchronously before deferred theme scripts.
 * Prevents native /cart/add form POST (full page navigation).
 */
(function () {
  if (window.__productAtcInit) return;
  window.__productAtcInit = true;

  window.theme = window.theme || {};
  window.theme.globalAjaxAtc = true;

  var adding = false;
  var COOLDOWN_MS = 5000;

  function cartRoute() {
    var themeObj = window.theme || (typeof theme !== 'undefined' ? theme : null);
    return (themeObj && themeObj.routes && themeObj.routes.cart) ? themeObj.routes.cart : '/cart';
  }

  /* The visible quantity box of this product (it can sit OUTSIDE the
     [data-product-form] element, linked only by form="<id>", and some
     scripts remove its name attribute). */
  function findQuantityInput(container) {
    var id = container.getAttribute('id');
    var el = null;
    if (id) {
      try {
        el = document.querySelector('[form="' + CSS.escape(id) + '"][data-quantity-input], [form="' + CSS.escape(id) + '"][name="quantity"]');
      } catch (e) { el = null; }
    }
    if (!el) {
      var scope = container.closest('product-form') || container.parentElement;
      el = scope ? scope.querySelector('.product__block__quantity [data-quantity-input], [data-quantity-input]') : null;
    }
    return el;
  }

  function getFormData(container) {
    if (!container) return new FormData();
    var fd;
    if (container.tagName === 'FORM') {
      fd = new FormData(container);
    } else {
      fd = new FormData();
      var seen = [];
      var add = function (el) {
        if (seen.indexOf(el) > -1) return;
        seen.push(el);
        if (!el.name || el.disabled) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        fd.append(el.name, el.value);
      };
      container.querySelectorAll('input, select, textarea').forEach(add);
      /* Fields outside the element but linked with form="<id>" */
      var id = container.getAttribute('id');
      if (id) {
        try {
          document.querySelectorAll('[form="' + CSS.escape(id) + '"]').forEach(function (el) {
            if (/^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) add(el);
          });
        } catch (e) {}
      }
    }
    /* Always use the quantity the customer sees in the quantity box */
    var qtyInput = findQuantityInput(container);
    if (qtyInput) {
      var q = parseInt(qtyInput.value, 10);
      if (q > 0) fd.set('quantity', String(q));
    }
    return fd;
  }

  function buildLineItem(formData) {
    var item = {
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity') || 1, 10)
    };
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    if (formData.get('selling_plan')) item.selling_plan = formData.get('selling_plan');
    return item;
  }

  function markCartActivity() {
    window.__cartAdding = true;
    window.__cartCooldown = true;
  }

  function clearCartAdding() {
    window.__cartAdding = false;
  }

  function startCartCooldown() {
    window.__cartCooldown = true;
    setTimeout(function () {
      window.__cartCooldown = false;
    }, COOLDOWN_MS);
  }

  function openCartDrawer(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));

    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }

    // Retry opening via events only (never click an <a href="/cart"> which can navigate).
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var d = document.querySelector('[data-drawer="drawer-cart"]');
      if (!d || d.classList.contains('drawer--visible') || attempts > 8) {
        clearInterval(timer);
        return;
      }
      d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }, 250);
  }

  function showError(container, message) {
    if (!container) return;
    var scope = container.closest('[data-error-boundary]') || container;
    var errorsEl = scope.querySelector('[data-error-display]');
    if (errorsEl) {
      errorsEl.innerHTML = '<div class="errors">' + message + '</div>';
      errorsEl.style.display = 'block';
    }
  }

  function ajaxAddToCart(container, btn) {
    if (adding) return;
    adding = true;
    markCartActivity();

    var formData = getFormData(container);
    var items = [buildLineItem(formData)];
    var mainQty = items[0].quantity;

    if (!items[0].id) {
      adding = false;
      clearCartAdding();
      showError(container, 'Please select a product option.');
      return;
    }

    var upsellScope =
      container.closest('[data-section-type="product"]') ||
      container.closest('.section-product') ||
      container.closest('.product-section') ||
      document;

    upsellScope.querySelectorAll('.slide-item .slide-upsell-item').forEach(function (upsellEl) {
      if (upsellEl.getAttribute('data-selected') !== 'true') return;
      var upsellId = parseInt(upsellEl.getAttribute('data-id'), 10);
      if (!upsellId) return;
      var upsellItem = {
        id: upsellId,
        quantity: mainQty
      };
      var color = upsellEl.getAttribute('data-property-color');
      if (color) upsellItem.properties = { Color: color };
      items.push(upsellItem);
    });

    btn.disabled = true;
    btn.classList.add('loading');

    var url = cartRoute();

    fetch(url + '/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data && data.status && data.status >= 400) throw data;
      return fetch(url + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).then(function (res) { return res.json(); });
    })
    .then(function (cart) {
      btn.classList.remove('loading');
      btn.classList.add('has-success');
      btn.removeAttribute('disabled');
      setTimeout(function () { btn.classList.remove('has-success'); }, 3500);
      openCartDrawer(cart);
      startCartCooldown();
    })
    .catch(function (err) {
      btn.classList.remove('loading');
      btn.removeAttribute('disabled');
      showError(container, (err && err.description) ? err.description : 'Could not add to cart. Please try again.');
      console.error('[product-atc]', err);
      window.__cartCooldown = false;
    })
    .finally(function () {
      adding = false;
      clearCartAdding();
    });
  }

  function findProductContainer(el) {
    return el.closest('[data-product-form]') || el.closest('form[action*="/cart/add"]') || el.closest('form');
  }

  function blockNativeProductForms() {
    document.querySelectorAll('form[data-product-form], form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.atcBlocked === 'true') return;
      form.dataset.atcBlocked = 'true';
      form.setAttribute('action', '#');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }, true);
      try {
        form.submit = function () {
          console.warn('[product-atc] Blocked native form.submit on product form');
        };
      } catch (e) { /* ignore */ }
    });
  }

  function inCartWindow() {
    return window.__cartAdding || window.__cartCooldown;
  }

  document.addEventListener('submit', function (e) {
    var target = e.target;
    if (!target) return;

    var action = (target.action && String(target.action)) || '';
    var isProductForm =
      (target.matches && target.matches('[data-product-form]')) ||
      action.indexOf('/cart/add') !== -1;

    // Always block native product-form submits.
    if (isProductForm) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }

    // During the add window, block any other cart-bound form submit
    // (e.g. a checkout/cart form being submitted programmatically by an app).
    if (inCartWindow() && action.indexOf('/cart') !== -1) {
      console.warn('[product-atc] BLOCKED form submit to "' + action + '" during cart add', target);
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // During the add window, block anchor navigations to the cart/checkout.
  document.addEventListener('click', function (e) {
    if (!inCartWindow()) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/\/(cart|checkout)(\/|\.js)?($|\?|#)/.test(href)) {
      console.warn('[product-atc] BLOCKED anchor navigation to "' + href + '" during cart add', a);
      e.preventDefault();
    }
  }, true);

  // Diagnostic only: log if the page unloads during the add window.
  // window.addEventListener('beforeunload', function () {
  //   if (inCartWindow()) {
  //     console.warn('[product-atc] PAGE UNLOADING during cart add window — a script navigated/reloaded. Check Network tab for the request.');
  //   }
  // });

  function handleAddClick(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    var navigateUrl = btn.getAttribute('data-navigate-url');
    if (navigateUrl) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign(navigateUrl);
      return;
    }

    var container = findProductContainer(btn);
    if (!container) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (btn.disabled || btn.classList.contains('loading') || adding) return;

    ajaxAddToCart(container, btn);
  }

  document.addEventListener('click', handleAddClick, true);

  // Safety net: a <button> without type="button" defaults to type="submit".
  // Inside product / upsell areas this can submit a native product form and
  // reload the page. Neutralize any such stray button (except our ATC and
  // intentional submit buttons like checkout).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn) return;
    if (btn.hasAttribute('data-add-to-cart')) return;
    if (btn.name === 'checkout' || btn.name === 'add') return;

    var type = (btn.getAttribute('type') || '').toLowerCase();
    if (type === 'button' || type === 'reset') return;

    var inProductArea = btn.closest(
      '[data-product-form], .nextgen_upsell, .slide-upsell-item, .upsell-image-modal-overlay, .custom-slider, .product__submit, [data-section-type="product"]'
    );
    if (!inProductArea) return;

    // Block the implicit form submission for these non-ATC buttons.
    e.preventDefault();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', blockNativeProductForms);
  } else {
    blockNativeProductForms();
  }

  document.addEventListener('shopify:section:load', blockNativeProductForms);
})();
